<template>
  <div id="manage">
    <div class="content">
        <div class="title">通知管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <Select v-model="platform_id" placeholder="请选择" class="borDiv" style="width:220px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="search(1)">
                            <Option v-for="item in platform_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="addRecruit">发布通知</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="columns7" :data="data6" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                teaShow:false,
                teaList:'',
                statusList:[],
                statusId:'',
                classDate:[],
                company_id:'',
                companyList:[],
                options3:{},
                name:'',
                keyword:'',
                level_id:'',
                levelArr:[],
                levalId:'',
                levelList:[],
                dance:'',
                danceList:[],
                dance_id:'',
                phone:'',
                teatsex:'0',
                teacher_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                platform_id:'',
                platform_list:[],
                columns7: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    {
                        title: '推荐人群',
                        align: 'center',
                        key: 'platform_name',
                    },
                    {
                        title: '标题',
                        align: 'center',
                        key: 'title',
                    },
                    {
                        title: '发送人',
                        align: 'center',
                        key: 'admin',
                        // render: (h, params) => {
                        //     // if(params.row.status==0){
                        //         return h('div', params.row.start_date+'至'+params.row.end_date);
                        //     // }
                        // }
                    },
                    {
                        title: '编辑时间',
                        align: 'center',
                        key:'updated_at',
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginLeft:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                let luder = {
                                                    "pageNum" : this.pageNum,
                                                    "platform_id" : this.platform_id
                                                };
                                                luder = JSON.stringify(luder);
                                                localStorage.setItem("luder", luder);
                                                this.$router.push({
                                                    path:'/manager/peizhi/newsList/newNotice',
                                                    query:{
                                                        notice_id:params.row.id,
                                                        platform_id_sel:params.row.platform
                                                    }
                                                })
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginLeft:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要这条通知?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deletenotice',{notice_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                this.search(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    },
                ],
                data6: [],
                alertShow:false,
                valm:0,
                num:0,
                tabId:0,
                maxnum:''
            }
        },
        methods:{
            dateChange1(value){
                this.classDate=value;
            },
            tanyes(index){
                let _this=this;
                let pattern=/^1[3456789]\d{9}$/;//手机号验证
                let patternemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(_this.name==''){
                    this.$Message.error('请输入期次名称');
                }
                else if(_this.classDate.length===0){
                    this.$Message.error('请选择期次日期');
                }
                else{
                    if(index==0){
                        _this.$axios.post('addterm',{
                            name:_this.name,
                            start_date:_this.classDate[0],
                            end_date:_this.classDate[1],
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                    if(index==1){
                        _this.$axios.post('editterm',{
                            term_id:_this.class_id,
                            name:_this.name,
                            start_date:_this.classDate[0],
                            end_date:_this.classDate[1],
                        }).then(res=>{
                            if(res.data.code==200){
                                _this.alertShow=false;
                                _this.search(0);
                            }
                            else{
                                this.$Message.error(res.data.message);
                            }
                        }).catch(function (error) {
                          console.log(error);
                        });
                    }
                }
            },
            tandel(){
                this.alertShow=false;
            },
            search(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getnoticelist',{
                    page:_this.pageNum,
                    platform:_this.platform_id,
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.data6=res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.search(0);
            },
            addRecruit(){
                let _this=this;
                localStorage.removeItem("luder");
                this.$router.push({
                    path:'/manager/peizhi/newsList/newNotice',
                    query:{}
                })
            },
            getplatform(index){
                let _this=this; 
                _this.$axios.post('getrecommendplatform',{}).then(res=>{
                    if(res.data.code==200){
                        _this.platform_list=res.data.data;
                        if(index==2){
                            _this.platform_id=res.data.data[0].id;
                        }
                        _this.search(1);
                    }
                    else{
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
        },
        created(){
            let _this=this; 
            let luder=JSON.parse(localStorage.getItem("luder"));
            if(luder!=null){
                _this.pageNum=luder.pageNum; 
                _this.platform_id=luder.platform_id;
                _this.getplatform(0)
            }
            else{
                _this.getplatform(2)
            }
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/peizhi/newsList.vue